<template>
  <vs-card>
    <ValidationObserver ref="billetReportFilterForm" v-slot="{ invalid }">
      <vs-row>
        <vs-col class="flex flex-col lg:w-1/5 w-full mb-4">
          <label for="Tipo de data">Tipo de data</label>
          <ValidationProvider
            name="Tipo de data"
            rules="required"
            v-slot="{ errors }"
          >
            <v-select
              v-model="filters.dateType"
              class="w-full"
              :options="dateTipeOptions"
              id="Tipo de data"
              name="Tipo de data"
              label="label"
              placeholder="Selecione"
              data-testid="billet-report-filter-date-type"
              :reduce="(option) => option.value"
              :class="!!errors.length ? 'has-error' : ''"
            ></v-select>
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="date-type-selection-error"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/5 w-full mb-4">
          <label for="Data Inicial">Data Inicial</label>
          <ValidationProvider
            name="Data Inicial"
            rules="required|validDate"
            v-slot="{ errors }"
          >
            <DatePicker
              id="Data Inicial"
              name="Data Inicial"
              class="w-full"
              v-model="filters.startDate"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              value-type="format"
              :editable="true"
              :lang="lang"
              v-mask="'##/##/####'"
              :input-class="['mx-input', !!errors.length ? 'has-error' : '']"
              data-testId="start-date-picker"
            />

            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="start-date-error"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/5 w-full mb-4">
          <label for="Data Final">Data Final</label>
          <ValidationProvider
            name="Data Final"
            rules="required|validDate|isEndDateSameOrAfter|daysRange"
            v-slot="{ errors }"
          >
            <DatePicker
              id="Data Final"
              name="Data Final"
              class="w-full"
              v-model="filters.endDate"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              value-type="format"
              :editable="true"
              :lang="lang"
              v-mask="'##/##/####'"
              :input-class="['mx-input', !!errors.length ? 'has-error' : '']"
              data-testId="end-date-picker"
            />
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="end-date-error"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/5 w-full mb-4">
          <label for="Status do boleto">Status do boleto</label>
          <v-select
            v-model="filters.billetStatus"
            class="w-full"
            :options="billetStatus"
            multiple
            clearable
            id="Status do boleto"
            name="Status do boleto"
            label="label"
            data-testid="billet-report-filter-billet-status"
            :reduce="(option) => option.value"
          ></v-select>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/5 w-full mb-4">
          <label for="Tipo de boleto">Tipo de boleto</label>
          <v-select
            v-model="filters.billetTypes"
            class="w-full"
            :options="billetTypes"
            multiple
            clearable
            id="Tipo de boleto"
            name="Tipo de boleto"
            label="label"
            data-testid="billet-report-filter-billet-type"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col class="flex flex-col lg:w-1/4 w-full mb-4">
          <label for="Tipo apólice">Tipo apólice</label>
          <v-select
            v-model="filters.policyTypes"
            class="w-full"
            :options="normalizedPolicyTypeOptions"
            multiple
            clearable
            id="policyType"
            name="Tipo apólice"
            label="label"
            data-testid="billet-report-filter-policy-type"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/4 w-full mb-4">
          <label for="Convênio">Convênio</label>
          <v-select
            v-model="filters.covenants"
            class="w-full"
            :options="covenants"
            multiple
            clearable
            id="Convênio"
            name="Convênio"
            label="label"
            data-testid="billet-report-filter-covenant"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/4 w-full mb-4">
          <label for="Assessoria">Assessoria</label>
          <v-select
            v-model="filters.consultancies"
            class="w-full"
            :options="consultancies"
            multiple
            clearable
            id="Assessoria"
            name="Assessoria"
            label="label"
            data-testid="billet-report-filter-consultancy"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/4 w-full mb-4">
          <label for="Corretora">Corretora</label>
          <v-select
            v-model="filters.brokers"
            class="w-full"
            :options="brokers"
            multiple
            clearable
            id="Corretora"
            name="Corretora"
            label="label"
            data-testid="billet-report-filter-broker"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row vs-align="flex-end" vs-justify="flex-end" vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <div class="flex justify-end mt-4">
            <vs-button
              color="#038803"
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              vs-w="2"
              class="pt-4 pb-4 mb-4 mt-2 mr-3 sm:mt-0"
              native-type="submit"
              data-testid="billet-report-send-button"
              :disabled="invalid"
              @click="send"
              >Gerar Relatório
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
    </ValidationObserver>
  </vs-card>
</template>
<script>
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from 'vee-validate';
import DatePicker from 'vue2-datepicker';
import ptBr from 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import { BILLET_REPORT_DATE_TYPES } from '../constants/billetReport.constant';
import {
  isDifferenceDays,
  isEndDateSameOrAfter,
} from '../../../../../utils/customValidator';
import functions from '../../../../../utils/functions';
import billetApi from '../../../../../services/billet.api';
import reportsApi from '../../../../../services/reports.api';
import moment from 'moment';
import { PRODUCT_TAG } from '../../../../../constants/tipo.apolice';
import dateConversion from '../../../../../utils/dateConversion';

export default {
  name: 'BilletReportFilter',
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePicker,
    vSelect,
  },
  data() {
    return {
      lang: ptBr,
      dateTipeOptions: BILLET_REPORT_DATE_TYPES,
      maxDaysRange: 31,
      billetTypes: [],
      billetStatus: [],
      policyTypeOptions: [],
      brokers: [],
      consultancies: [],
      covenants: [],
      filters: {
        dateType: null,
        startDate: null,
        endDate: null,
        billetTypes: [],
        billetStatus: [],
        policyTypes: [],
        brokers: [],
        consultancies: [],
        covenants: [],
      },
    };
  },
  computed: {
    normalizedPolicyTypeOptions() {
      return this.policyTypeOptions.map((option) => {
        return { ...option, label: PRODUCT_TAG[option.id] };
      });
    },
  },
  watch: {
    filters: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  created() {
    Validator.extend('daysRange', {
      getMessage: () =>
        `O periodo deve ser de no máximo ${this.maxDaysRange} dias`,
      validate: (value) =>
        isDifferenceDays(this.filters.startDate, value, this.maxDaysRange),
    });
    Validator.extend('isEndDateSameOrAfter', {
      getMessage: () => `A data final deve ser maior que a data inicial`,
      validate: (value) => isEndDateSameOrAfter(this.filters.startDate, value),
    });
  },
  mounted() {
    this.getDomains();
  },
  methods: {
    validateForm() {
      this.$nextTick(() => {
        this.$refs.billetReportFilterForm.validate();
      });
    },
    getDomains() {
      functions.buscaDadosSelects(
        'domTiposBoletos',
        this.billetTypes,
        'tipoBoleto',
        'idTipoBoleto',
      );
      functions.buscaDadosSelects(
        'tipoApolices',
        this.policyTypeOptions,
        'nome',
        'tipoApoliceId',
      );
      billetApi.getBilletSituations().then((response) => {
        this.billetStatus = response.map(({ situation }, index) => ({
          id: index + 2,
          label: situation,
          value: situation,
        }));
        this.billetStatus.unshift({
          id: 1,
          label: 'VENCIDO',
          value: 'VENCIDO',
        });
      });
      reportsApi.getFullContext().then((response) => {
        this.brokers = response.brokers;
        this.consultancies = response.consultancies;
        this.covenants = response.covenants;
      });
    },
    async send() {
      const valid = await this.$refs.billetReportFilterForm.validate();
      if (!valid) {
        return;
      }
      const startDate =
        dateConversion.convertDateToISO(this.filters.startDate) + 'T00:00:00';
      const endDate =
        dateConversion.convertDateToISO(this.filters.endDate) + 'T23:59:59';
      this.$emit('export', {
        ...this.filters,
        startDate,
        endDate,
      });
    },
  },
};
</script>
